import React from 'react';
import { UserModel } from 'models';
import { Button, IconButton } from '@mui/material';
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';

export default function UserStatistics({ id, title = 'آمار' }) {
  return (
    <>
      <UserModel
        isPopup
        isAssign={false}
        disabled={false}
        multiSelect={false}
        title={title}
        // onAssign={onAssign}
        assigning={false}
        initFilter={{ coupon_id: id, used_this_coupon: 'HAVE' }}
        preSelected={[]}
        action={
          <Button
            size="small"
            color="info"
            variant="outlined"
            startIcon={<AssignmentRoundedIcon fontSize="small" />}
          >
            {title}
          </Button>
        }
      />
    </>
  );
}
